import { SPARKY_ROOT_ELEMENT_TAG_NAME, DEFAULT_ROOT_ELEMENT_ID } from '../init/initConst'
export const ROOT_ELEMENT_QUERY = `${SPARKY_ROOT_ELEMENT_TAG_NAME},#${SPARKY_ROOT_ELEMENT_TAG_NAME},#${DEFAULT_ROOT_ELEMENT_ID}`

export const getRootElement = (): HTMLElement | null => {
  return document.querySelector(ROOT_ELEMENT_QUERY)
}

export const showLoadingMask = (show: boolean = true) => {
  const needToShow = Boolean(show)
  const { classList } = getRootElement()!
  const hasLoadingCls = classList.contains('loading')
  if (needToShow === hasLoadingCls) {
    return
  }
  if (needToShow) {
    classList.add('loading')
  }
  else if (classList.contains('sparky-hub-nav')) { // hub do not need fading
    classList.remove('loading')
  }
  else {
    classList.add('fading')
    setTimeout(() => {
      classList.remove('loading', 'fading')
    }, 1000)
  }
}

export const clearLoadingMask = () => showLoadingMask(false)
